import React from 'react';
import translate from '../Translate.js';
import * as icons from '../Icons/Icons';

class MFASetup extends React.Component {
  constructor() {
    super();
    this.state = {
      qrCode: null,
      secret: null,
      code: '',
      loading: true,
      verifying: false,
      error: null
    };
    this.handleCodeInput = this.handleCodeInput.bind(this);
    this.verifyCode = this.verifyCode.bind(this);
  }

  componentDidMount() {
    const userSid = sessionStorage.getItem('mfaUserSid');
    const installSid = sessionStorage.getItem('mfaInstallSid');
    const account = this.getParameterByName('account') || sessionStorage.getItem('mfaAccount');

    // Store account parameter if present
    if (account) {
      sessionStorage.setItem('mfaAccount', account);
    }

    if (!userSid || !installSid) {
      this.props.routing.push('/account/sign-in');
      return;
    }

    this.props.store.SessionStore.setupMFA(userSid, installSid, (error, data) => {
      if (error) {
        this.setState({ error: 'Failed to initialize MFA setup. Please try again.', loading: false });
      } else {
        this.setState({ 
          qrCode: data.qrCode, 
          secret: data.secret,
          loading: false 
        });
      }
    });
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  handleCodeInput(e) {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
    this.setState({ code: value, error: null });
  }

  verifyCode(e) {
    e.preventDefault();
    
    if (this.state.code.length !== 6) {
      this.setState({ error: 'Please enter a 6-digit code' });
      return;
    }

    const userSid = sessionStorage.getItem('mfaUserSid');
    const installSid = sessionStorage.getItem('mfaInstallSid');

    this.setState({ verifying: true, error: null });

    this.props.store.SessionStore.verifyMFASetup(userSid, installSid, this.state.code, (error) => {
      if (error) {
        this.setState({ 
          error: 'Invalid code. Please try again.', 
          verifying: false,
          code: ''
        });
      } else {
        sessionStorage.removeItem('mfaUserSid');
        sessionStorage.removeItem('mfaInstallSid');
        sessionStorage.removeItem('mfaAccount');
        
        // Redirect to dashboard after successful MFA setup
        this.props.routing.push('/');
      }
    });
  }

  render() {
    const { qrCode, secret, code, loading, verifying, error } = this.state;
    const backgroundImg = 'url(./static/img/bg-sign-up.jpg)';

    if (loading) {
      return (
        <main className="page page--graphic page--pane-right" style={{backgroundImage: backgroundImg}}>
          <div className="page--graphic__content wrap">
            <img src="./static/img/logo-white.png" width="300" alt="SmarterProctoring" />
          </div>
          <div className="pane pane--right pane--fixed">
            <div className="pane__content">
              <h1 className="pane__title">Setting up MFA...</h1>
            </div>
          </div>
        </main>
      );
    }

    return (
      <main className="page page--graphic page--pane-right" style={{backgroundImage: backgroundImg}}>
        <div className="page--graphic__content wrap">
          <img src="./static/img/logo-white.png" width="300" alt="SmarterProctoring" />
        </div>
        <div className="pane pane--right pane--fixed">
          <div className="pane__content">
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <i className="page--error__icon" style={{ color: '#4CAF50' }}>
                <icons.iconLock />
              </i>
            </div>
            
            <h1 className="pane__title" style={{ textAlign: 'center' }}>Set Up Multi-Factor Authentication</h1>
            
            <p className="meta" style={{ marginBottom: '30px', textAlign: 'center' }}>
              Enhance your account security by setting up two-factor authentication
            </p>

            {qrCode && (
              <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <p className="meta" style={{ marginBottom: '15px', fontWeight: '500' }}>
                  Step 1: Scan this QR code with your authenticator app
                </p>
                <p className="meta" style={{ marginBottom: '20px', fontSize: '13px', color: '#666' }}>
                  (Google Authenticator, Authy, Microsoft Authenticator, etc.)
                </p>
                <div style={{ 
                  display: 'inline-block',
                  padding: '20px',
                  background: '#fff',
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                  <img src={qrCode} alt="MFA QR Code" style={{ width: '200px', height: '200px', display: 'block' }} />
                </div>
              </div>
            )}

            {secret && (
              <div style={{ marginBottom: '30px' }}>
                <p className="meta" style={{ marginBottom: '10px', textAlign: 'center', fontWeight: '500' }}>
                  Or enter this code manually:
                </p>
                <div style={{
                  padding: '15px',
                  background: '#f8f9fa',
                  border: '1px solid #dee2e6',
                  borderRadius: '4px',
                  textAlign: 'center',
                  marginBottom: '10px'
                }}>
                  <code style={{ 
                    fontFamily: 'Monaco, Consolas, monospace',
                    fontSize: '16px',
                    fontWeight: '600',
                    letterSpacing: '2px',
                    color: '#333'
                  }}>
                    {secret}
                  </code>
                </div>
              </div>
            )}

            <form onSubmit={this.verifyCode} noValidate>
              <p className="meta" style={{ marginBottom: '15px', fontWeight: '500', textAlign: 'center' }}>
                Step 2: Enter the 6-digit code from your app
              </p>
              
              <fieldset>
                <ul className="fields">
                  <li>
                    <label className="meta" htmlFor="mfa-code">Verification Code</label>
                    <input 
                      type="text" 
                      id="mfa-code" 
                      placeholder="000000"
                      value={code}
                      onChange={this.handleCodeInput}
                      maxLength="6"
                      pattern="[0-9]*"
                      inputMode="numeric"
                      required 
                      aria-required="true"
                      autoFocus
                      disabled={verifying}
                      style={{ textAlign: 'center', fontSize: '18px', letterSpacing: '4px' }}
                    />
                  </li>
                </ul>
              </fieldset>

              {error && (
                <div className="notice notice--error" style={{ marginBottom: '15px' }}>
                  <p>{error}</p>
                </div>
              )}

              <button className="btn" type="submit" disabled={verifying || code.length !== 6}>
                {verifying ? 'Verifying...' : 'Verify & Complete Setup'}
              </button>
            </form>

            <div style={{ marginTop: '20px', padding: '15px 20px', background: '#d1ecf1', borderLeft: '4px solid #0c5460', borderRadius: '4px' }}>
              <p style={{ fontSize: '14px', margin: 0, color: '#0c5460', lineHeight: '1.6', fontWeight: '400' }}>
                <strong style={{ fontWeight: '600' }}>Tip:</strong> Keep your authenticator app accessible. You'll need it every time you sign in.
              </p>
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default translate('MFASetup')(MFASetup);



// WEBPACK FOOTER //
// ./src/app/components/Account/MFASetup.js